import React from 'react';
import { MessageCircle } from 'lucide-react';
export function Footer() {
  return <footer className="bg-[#050505] border-t border-[#1a1a1a] py-12" data-id="element-10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-11">
        <div className="flex flex-col md:flex-row justify-between items-center gap-8" data-id="element-12">
          <div className="text-center md:text-left" data-id="element-13">
            <h2 className="text-2xl font-serif text-white mb-2" data-id="element-14">KKbaby</h2>
            <p className="text-gray-500 text-sm" data-id="element-15">
              Your Trusted Companion in Singapore
            </p>
          </div>

          <div className="flex flex-col items-center md:items-end gap-4" data-id="element-16">
            <button className="flex items-center gap-2 px-6 py-3 bg-[#D4AF37] text-black font-medium rounded hover:bg-[#C5A55A] transition-colors" data-id="element-17">
              <MessageCircle className="w-5 h-5" data-id="element-18" />
              <span data-id="element-19">Contact Us</span>
            </button>
            <p className="text-xs text-gray-600" data-id="element-20">
              © {new Date().getFullYear()} KKbaby. All rights reserved. 18+
              Only.
            </p>
          </div>
        </div>
      </div>
    </footer>;
}